import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { getGradeWeight, updateTypesStudySessions } from '../../actions/directory'
import styles from './styles.module.scss'

export default function TypesStudySessionsModalSimple({ data, closeModal }) {
  const dispatch = useDispatch()
  const { gradeWeight } = useSelector(state => state.directory)

  const addMode = !data?.typeid

  useEffect(() => {
    dispatch(getGradeWeight())
  }, [])

  const { values, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: addMode ? {
      default_weight: 0,
      fixed_weight: 0,
      IsAvailableDO: false,
      IsAvailableVD: false,
      ismain: 0,
      istest: 0,
      no_access: null,
      typeid: '',
      typename: '',
    } : data,
    enableReinitialize: true,
    onSubmit: (formValues) => {
      dispatch(updateTypesStudySessions({
        ...formValues,
        icon: 'task.gif',
        fixed_weight: formValues.fixed_weight ? 1 : 0,
        istest: formValues.istest ? 1 : 0,
      }))
      closeModal()
    }
  })

  const toggleField = (name) => () => setFieldValue(name, !values[name])
  const isUsed = values.no_access === 0
  const toggleUsed = () => setFieldValue('no_access', isUsed ? 1 : 0)

  if (!data) return null

  return (
    <div className={styles.simpleOverlay} onClick={closeModal}>
      <div className={styles.simplePanel} onClick={(e) => e.stopPropagation()}>
        <div className={styles.simpleBody}>
          <label className={styles.simpleLabel}>
            <span>Тип учебного процесса</span>
            <input className={styles.simpleInput} value={values?.typename || ''} disabled readOnly />
          </label>

          <div>
            <span className={styles.simpleGroupLabel}>Доступность</span>
            <div className={styles.simpleCheckRow}>
              <label className={styles.simpleCheckbox}>
                <input type='checkbox' checked={!!values.isavailable} onChange={toggleField('isavailable')} />
                Доступен основное
              </label>
              <label className={styles.simpleCheckbox}>
                <input type='checkbox' checked={!!values.isavailabledo} onChange={toggleField('isavailabledo')} />
                Доступен ДО
              </label>
              <label className={styles.simpleCheckbox}>
                <input type='checkbox' checked={!!values.isavailablevd} onChange={toggleField('isavailablevd')} />
                Доступен ВД
              </label>
              <label className={styles.simpleCheckbox}>
                <input type='checkbox' checked={!!values.is_used} onChange={toggleField('is_used')} />
                Используется
              </label>
            </div>
          </div>

          <div>
            <span className={styles.simpleGroupLabel}>Вес оценок по умолчанию</span>
            <div className={styles.simpleWeightRow}>
              <select className={styles.simpleSelect} name='default_weight' value={values?.default_weight} onChange={handleChange}>
                {gradeWeight?.map(({ weight }) => <option key={weight} value={weight}>{weight}</option>)}
              </select>
              <label className={styles.simpleCheckbox}>
                <input type='checkbox' checked={!!values.fixed_weight} onChange={toggleField('fixed_weight')} />
                Можно редактировать веса оценок
              </label>
            </div>
          </div>

          <label className={styles.simpleCheckbox}>
            <input type='checkbox' checked={!!values.istest} onChange={toggleField('istest')} />
            Участвует в КОУ, СОУ, % усп.
          </label>
        </div>

        <div className={styles.simpleFooter}>
          <button type='button' className={styles.simpleSaveBtn} onClick={handleSubmit}>Сохранить</button>
          <button type='button' className={styles.simpleCloseBtn} onClick={closeModal}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}
